module.exports = __webpack_public_path__ + "media/ToDust-midas-syndrome.a3d96ef7.mp3";